export default "__VITE_ASSET__DklmKrGG__"